import type { Priority } from "../data/types";

/**
 * P1–P4 badge. P1/P2 carry status colour because they are the ones that should
 * catch the eye; P3/P4 stay neutral so a list of them does not read as alarming.
 */
const TONE: Record<Priority, string> = {
  0: "text-white bg-error-600",
  1: "text-error-700 bg-error-50",
  2: "text-warning-700 bg-warning-50",
  3: "text-gray-700 bg-gray-100",
  4: "text-gray-500 bg-gray-100",
};

export function PriorityBadge({ priority }: { priority: Priority }) {
  return (
    <span
      className={`inline-flex h-5 w-[26px] flex-none items-center justify-center rounded-xs text-[11px] font-semibold tracking-[0.01em] ${TONE[priority]}`}
    >
      P{priority}
    </span>
  );
}
